import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import moment from 'moment'
import { withRouter } from 'react-router'
import { MsalContext } from "@azure/msal-react"
import { initializeFirebase, requestForToken} from "../firebase";
import { MainNav, LeftDrawer, SearchBar, KeyCodes, Colors, Title2, Modal, } from 'advenio-components'
import { AuthRedux, getCookie } from 'auth-advenio'
import ActivityActions from '../Data/Redux/ActivityRedux'
import ClassroomActions from '../Data/Redux/ClassroomRedux'
import UsersActions from '../Data/Redux/UsersRedux'
import CentersInfoActions from '../Data/Redux/CentersInfoRedux'
import GroupActivityButton from '../Components/Activity/GroupActivityButton'
import { PLATFORMS_LINKS, SENTRY_ENV, getPlatformLink, API_DOMAIN, MSG_SUPPORT,DATE_SUPPORT, TIME_SUPPORT } from '../config'
import { ChatWidget } from 'advenio-chat-ia'
import * as Sentry from '@sentry/browser';
import { userAgent } from '..'
import ModalSupport from '../shared/ModalSupport'
import {isNil} from "ramda";
import {gb, featuresReady, setGrowthBookUser, useFeatureIsOn} from "../utils/growthbook";
import {stringContainsExactlyOf} from "../utils/Utils";


const defaultProfileImage = 'https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png'


const SearchContainer = styled.div`
  width:100%;
  height: calc(100% - 32px);
  background-color: rgba(0, 0, 0, 0.6);
  display: ${({ active }) => active ? 'flex' : 'none'};
  position: absolute;
  z-index: 19;
  flex-direction: row;
  margin-top: ${({ impersonating }) => impersonating ? '105px' : '56px'};
  top: 0;
  left: 0;
  align-items: flex-start;
  justify-content: center;
`
const SearchBox = styled.div`
  width: 60%;
  max-height: calc(100% - 100px);
  background-color: #FFFFFF;
  display: flex;
  border: solid 1px #FFFFFF;
  border-radius: 3px;
  flex-direction: column;
  margin-top: ${({ impersonating }) => impersonating ? '4px' : '8px'};
  align-items: center;
  justify-content: center;
  @media (max-width: 763px) {
    width: 100%;
  }
`
const SearchStudentDiv = styled.div`
  width: 100%;
  height: 50px;
  background-color: ${({ active }) => active ? '#008CE0' : '#CCCCCC'};
  margin-top: 5px;
  border-radius: 5px;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
  &:hover{
      background-color: #008CE0;
      div {
        color: #FFFFFF;
      }
  }
`

const SearchStudentContainer = styled.div`
  width: 99%;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  margin-bottom: 5px;
  overflow-y: auto;
  cursor: pointer;
`

const SearchStudentInfo = styled.div`
  width: 60%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  margin-left: 10px;
  color: ${({ active }) => active ? '#FFFFFF' : '#000000'};
`
const StudentName = styled.div`
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  margin-left: 10px;
`

const InitialDiv = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: #75B753;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
  @media (max-width: 763px) {
    width: 15px;
    height: 15px;
    font-size: 9px;
  }
`

const SeeProfile = styled.div`
  width: 40%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: row;
  margin-right: 10px;
  color: #FFFFFF;
`

const Impersonate = styled.div`
  width: 100%;
  height: 50px;
  background: ${Colors.blue500};
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
`
const Underline = styled.span`
  text-decoration: underline;
  cursor: pointer;
`

const NoResults = styled.div`
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #757575;
`

const Img = styled.img`
  margin-right: 8px;
`
const TituloQA = styled.div`
  width:100%;
`

const initialPage = { id: 1, name: 'Centros', link: '/' }

const nursePages = [
  initialPage,
  { id: 2, name: 'Medicamentos', link: '/medicine' },
  { id: 3, name: 'Checkin Virtual', link: '/virtual-checkin' },
  // { id: 22, name: 'Checkin con Qr', link: '/scann-qr' },
]

const normalPages = [
  initialPage,
  { id: 2, name: 'Checkin Virtual', link: '/virtual-checkin' },
  { id: 3, name: 'Inscripciones', link: '/enrollments' },
  { id: 4, name: 'Recordatorios', link: '/payment-reminders' },
  { id: 5, name: 'Medicamentos', link: '/medicine' },
  { id: 6, name: 'Validaciones', link: '/unvalidated-receipts' },
  { id: 7, name: 'Servicio Ocasional', link: '/occasional' },
]

const directorPages = [
  { id: 1, name: 'Dashboard', link: '/' },
  { id: 2, name: 'Niños', link: '/children' },
  { id: 3, name: 'Checkin Virtual', link: '/virtual-checkin' },
  // { id: 22, name: 'Checkin con Qr', link: '/scann-qr' },
  { id: 4, name: 'Inscripciones', link: '/enrollments' },
  { id: 5, name: 'Recordatorios', link: '/payment-reminders' },
  { id: 6, name: 'Medicamentos', link: '/medicine' },
  { id: 7, name: 'Validaciones', link: '/unvalidated-receipts' },
  { id: 8, name: 'Fotos', link: '/unvalidated-photos' },
  { id: 9, name: 'Videos', link: '/videos' },
  // { id: 11, name: 'Reservaciones B2B', link: '/reservations-b2b' },
  { id: 10, name: 'Reservaciones Home', link: '/reservations-home' },
  { id: 11, name: 'Servicio Ocasional', link: '/occasional' },
  { id: 13, name: 'Documentos', link: '/documents' },
  /* // descommment to producction */
  // { id: 11, name: 'Cursos', link: '/courses',list:[
  //   {label:'Crear Perfil', path:'/courses-create-profile' },
  //   {label:'Informacion', path:'/courses-info' },
  // ]},
  { id: 12, name: 'Reportes', link: '/reports', list: [
    { label: 'Asistencias', path: '/attendance' },
    // { label: 'Niños', path: '/kids' },
    // { label: 'Finanzas', path: '/finances' },
    // { label: 'Ratings', path: '/ratings' },
    { label: 'Incidentes', path: '/incidents' },
    { label: 'Altas', path: '/enrollment' },
    { label: 'Bajas', path: '/disenrollment' },
    { label: 'Lista Maestra', path: '/masterlist' },
    { label: 'Cargos Sin Recibo', path: '/receipt' },
    { label: 'Recibos Sin Validar', path: '/unvalidated-receipts-report' },
    { label: 'Domiciliaciones', path: '/domiciliation-report' },
  ] },
]

const coordinatorPages = [
  initialPage,
  { id: 2, name: 'Checkin Virtual', link: '/virtual-checkin' },
  { id: 3, name: 'Inscripciones', link: '/enrollments' },
  { id: 4, name: 'Recordatorios', link: '/payment-reminders' },
  { id: 5, name: 'Medicamentos', link: '/medicine' },
  { id: 7, name: 'Validaciones', link: '/unvalidated-receipts' },
  { id: 8, name: 'Fotos', link: '/unvalidated-photos' },
  { id: 9, name: 'Videos', link: '/videos' },
  // { id: 11, name: 'Reservaciones B2B', link: '/reservations-b2b' },
  { id: 10, name: 'Reservaciones Home', link: '/reservations-home' },
  { id: 11, name: 'Servicio Ocasional', link: '/occasional' },
  { id: 12, name: 'Documentos', link: '/documents' },
]

const teacherPages = [
  initialPage,
  // { id: 22, name: 'Checkin con Qr', link: '/scann-qr' },
]

const backOfficePages = [
  { id: 1, name: 'Dashboard', link: '/' },
  { id: 2, name: 'Reportes', link: '/', list: [
    { label: 'BI', path: '/reports-bi' },
    { label: 'Asistencias', path: '/attendance' },
    // { label: 'Niños', path: '/kids' },
    // { label: 'Finanzas', path: '/finances' },
    // { label: 'Ratings', path: '/ratings' },
    { label: 'Incidentes', path: '/incidents' },
    { label: 'Altas', path: '/enrollment' },
    { label: 'Bajas', path: '/disenrollment' },
    { label: 'Lista Maestra', path: '/masterlist' },
    { label: 'Cargos Sin Recibo', path: '/receipt' },
    { label: 'Recibos Sin Validar', path: '/unvalidated-receipts-report' },
    { label: 'Domiciliaciones', path: '/domiciliation-report' },
    { label: 'Medallia', path: '/medallia' },
  ] },
  { id: 3, name: 'Busqueda Avanzada', link: '/advanced-search' },
]

/**
 * POC GrowthBook — Banner visible solo para emails en targeting.
 * Feature key: "poc-email-target"
 * Crea este feature en la UI de GrowthBook con una regla Force Value
 * donde condition sea: email is in list ["jose.valero@talisis.com"]
 */
const GrowthBookBanner = () => {
  const showBanner = useFeatureIsOn("poc-email-target")

  if (!showBanner) return null

  return (
    <div style={{
      background: "linear-gradient(90deg, #6366f1, #8b5cf6)",
      color: "#fff",
      padding: "12px 24px",
      textAlign: "center",
      fontSize: "14px",
      fontWeight: 500,
    }}>
      🚀 POC GrowthBook activo — Este banner solo lo ves TÚ (targeting por email)
    </div>
  )
}

class Layout extends Component {

  static contextType = MsalContext

  constructor(props) {
    super(props)
    this.state = {
      userName: 'Kenneth',
      drawerOpened: false,
      students: [],
      results: [],
      platforms: [],
      activePlatformIndex: 0,
      index: 0,
      empty: true,
      support: {is_support:false},
      chatIaEnabled: false,
    }
  }

  componentWillMount() {
    // TODO: Refactor this - it has terrible performance implications.
    // We don't want to rely on having the user object stored in the props for every section
    // of the app. It would be better to do this once from AppContainer and store the result
    // in the user redux store.
    const { user } = this.props

    if (user) {

      Sentry.setUser({
        "id":user.id,
        "email":`${user.email}`,
        "username":`${user.first_name+' '+user.last_name_paternal}`,
      });
        Sentry.setExtra( "UserId", `${user.userable_id}`);
        Sentry.setExtra( "UserType", `${user.user_type}`);
        Sentry.setExtra( "Role", `${user.role}`);
        Sentry.setExtra( "Center", `${user.center_id}`);
        Sentry.addBreadcrumb({
          category: "Debug",
          message: "View Principal",
          level: "debug",

      });
      console.log('layout', user)
      // GrowthBook: setear atributos del usuario para targeting
      setGrowthBookUser(user)

      // GrowthBook: leer features desde el SDK (pueden no estar listos aún)
      this.updateGrowthBookFeatures()

      // Suscribirse a cambios de features (streaming/refresh posteriores)
      this._gbUnsubscribe = gb.subscribe(() => {
        this.updateGrowthBookFeatures()
      })

      // Esperar carga inicial de features y actualizar
      featuresReady.then(() => {
        this.updateGrowthBookFeatures()
      })

      let activePlatformIndex = 0

      const platforms = user.platform_permissions.map((platform, index) => {
        if (platform === 'MiAdvenio') {
          activePlatformIndex = index
        }

        return {
          id: index,
          name: platform,
          link: platform.toLowerCase(),
        }
      })
      window.gtag('event', 'layout_init', {
        event_category: 'information',
        event_label: 'center id',
        value: Number(user.center_id)
          })
      window.gtag('event', 'layout_init', {
        event_category: 'information',
        event_label: 'User id',
        value: Number(user.id)
          })

      this.setState({ platforms, activePlatformIndex })

      const setTokenFCM = async ()=> {
        initializeFirebase
        const token = await requestForToken()

        const blobObj = localStorage.getItem('advenio_token_fcm') || null;
          if(blobObj === null || token !== blobObj){
            const { user:{ id }, postUserTokenFCM } =this.props
            postUserTokenFCM(id,{'token_fcm':token,"device_type":"web"})
            localStorage.setItem('advenio_token_fcm',token)

          }
      }

      if (userAgent.includes('Chrome/') || userAgent.includes('Firefox/') || userAgent.includes('Edg/')) {
        setTokenFCM()
      }

    }
  }

  componentDidMount(){
    const { postUserPicture, user:{id,profile_pictures}, loadingPic } = this.props
    const blobObj = localStorage.getItem('image_profile') || null;
    if(profile_pictures === null && blobObj !== null){
       postUserPicture(id,{'profile_pic':blobObj})
    }
  }

  componentWillUnmount() {
    if (typeof this._gbUnsubscribe === "function") {
      this._gbUnsubscribe()
    }
  }

  updateGrowthBookFeatures = () => {
    var maintenanceValue = gb.getFeatureValue("app-maintenance", null)
    if (!isNil(maintenanceValue)) {
      this.setState({ support: maintenanceValue })
    }
    var chatIaValue = gb.getFeatureValue("chat-ia", null)
    console.log('[GrowthBook] chat-ia value:', chatIaValue, '| attributes:', gb.getAttributes())
    if (!isNil(chatIaValue)) {
      this.setState({ chatIaEnabled: chatIaValue.enabled || false })
    } else {
      this.setState({ chatIaEnabled: false })
    }
  }
  componentWillReceiveProps(nextProps) {
    const { totalStudents } = nextProps
    if (totalStudents.length !== this.state.students.length) {
      this.setState({ students: totalStudents })
    }
    // Si el usuario cambió (stop impersonation), actualizar GrowthBook
    if (nextProps.user && nextProps.user.id !== this.props.user.id) {
      setGrowthBookUser(nextProps.user)
        .then(() => this.updateGrowthBookFeatures())
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { index, results } = this.state
    const newState = { ...this.state }

    if (prevState.index !== index) {
      for (let i = 0; i < results.length; i += 1) {
        if (i === index) {
          newState.results[i].active = true
        } else {
          newState.results[i].active = false
        }
      }

      this.setState(newState)
    }

    if (this.props.isSearchBarOpen) {
      const bodyElement = document.querySelector('body')
      bodyElement.style.position = 'fixed'
      bodyElement.style.height = '100%'
      bodyElement.style.width = '100%'
    } else {
      const bodyElement = document.querySelector('body')
      bodyElement.style.position = ''
    }
  }

  /**
   * Fired after new page is selected. Receives the link to follow.
   */
  onPageSelected = link => this.props.goTo(link)

  /**
   * Fired after new platform is selected. Receives the link to follow.
   */
  onPlatformSelected = link => window.location.assign(getPlatformLink(link))

  onChange = (e) => {
    const { students } = this.state
    const { currentTarget: { value: currentValue } } = e
    this.props.setSearchName(currentValue)
    let results = []
    if (currentValue) {
      if (currentValue !== '') {
        for (let i = 0; i < students.length; i += 1) {
          const nameToSearch = `${students[i].student.first_name || ''} ${students[i].student.last_name_paternal || ''} ${students[i].student.last_name_maternal || ''}`
          const nameFolded = this.accentFold(nameToSearch.toLowerCase())
          const qFolded = this.accentFold(currentValue.toLowerCase())

          if (nameFolded.match(qFolded)) {
            if (results.length === 0) {
              results.push({ student: students[i], active: true })
            } else {
              results.push({ student: students[i], active: false })
            }
          }
        }
        this.setState({ results, empty: false })
      }
    } else {
      results = []
      this.setState({ results, empty: true, index: 0 })
    }
  }

  onKeyDown = (e) => {
    const {
      classrooms,
      closeSearchBar, goTo, setActiveStudentId, setActiveClassroomId, setSearchName } = this.props
    const { index, results } = this.state

    const key = e.which

    switch (key) {
      case KeyCodes.DOWN:
        if (index < results.length - 1) {
          this.setState({ index: index + 1 })
        }
        break
      case KeyCodes.UP:
        if (index > 0 && index <= results.length - 1) {
          this.setState({ index: index - 1 })
        }
        break
      case KeyCodes.ESC:
        closeSearchBar()
        break
      case KeyCodes.ENTER:
        if (results.length > 0) {
          const [foundStudent] = results.filter(student => student.active)
          const { student: activeStudent } = foundStudent
          const { student: { id: activeStudentId } } = activeStudent
          const [classroom] = classrooms.filter(room => room.name === activeStudent.classroom)
          const studentName = `${activeStudent.student.first_name || ''} ${activeStudent.student.last_name_paternal || ''} ${activeStudent.student.last_name_maternal || ''}`
          setSearchName(studentName)
          setActiveStudentId(Number(activeStudentId))
          setActiveClassroomId(Number(classroom.id))
          goTo(`/classroom/${classroom.id}/student/${activeStudentId}`)
          closeSearchBar()
        }
        break

      default:
        break
    }
  }

  accentFold = (s) => {
    if (!s) { return '' }

    const accent_map = {'ẚ': 'a', 'Á': 'a', 'á': 'a', 'À': 'a', 'à': 'a', 'Ă': 'a', 'ă': 'a', 'Ắ': 'a', 'ắ': 'a', 'Ằ': 'a', 'ằ': 'a', 'Ẵ': 'a', 'ẵ': 'a', 'Ẳ': 'a', 'ẳ': 'a', 'Â': 'a', 'â': 'a', 'Ấ': 'a', 'ấ': 'a', 'Ầ': 'a', 'ầ': 'a', 'Ẫ': 'a', 'ẫ': 'a', 'Ẩ': 'a', 'ẩ': 'a', 'Ǎ': 'a', 'ǎ': 'a', 'Å': 'a', 'å': 'a', 'Ǻ': 'a', 'ǻ': 'a', 'Ä': 'a', 'ä': 'a', 'Ǟ': 'a', 'ǟ': 'a', 'Ã': 'a', 'ã': 'a', 'Ȧ': 'a', 'ȧ': 'a', 'Ǡ': 'a', 'ǡ': 'a', 'Ą': 'a', 'ą': 'a', 'Ā': 'a', 'ā': 'a', 'Ả': 'a', 'ả': 'a', 'Ȁ': 'a', 'ȁ': 'a', 'Ȃ': 'a', 'ȃ': 'a', 'Ạ': 'a', 'ạ': 'a', 'Ặ': 'a', 'ặ': 'a', 'Ậ': 'a', 'ậ': 'a', 'Ḁ': 'a', 'ḁ': 'a', 'Ⱥ': 'a', 'ⱥ': 'a', 'Ǽ': 'a', 'ǽ': 'a', 'Ǣ': 'a', 'ǣ': 'a', 'Ḃ': 'b', 'ḃ': 'b', 'Ḅ': 'b', 'ḅ': 'b', 'Ḇ': 'b', 'ḇ': 'b', 'Ƀ': 'b', 'ƀ': 'b', 'ᵬ': 'b', 'Ɓ': 'b', 'ɓ': 'b', 'Ƃ': 'b', 'ƃ': 'b', 'Ć': 'c', 'ć': 'c', 'Ĉ': 'c', 'ĉ': 'c', 'Č': 'c', 'č': 'c', 'Ċ': 'c', 'ċ': 'c', 'Ç': 'c', 'ç': 'c', 'Ḉ': 'c', 'ḉ': 'c', 'Ȼ': 'c', 'ȼ': 'c', 'Ƈ': 'c', 'ƈ': 'c', 'ɕ': 'c', 'Ď': 'd', 'ď': 'd', 'Ḋ': 'd', 'ḋ': 'd', 'Ḑ': 'd', 'ḑ': 'd', 'Ḍ': 'd', 'ḍ': 'd', 'Ḓ': 'd', 'ḓ': 'd', 'Ḏ': 'd', 'ḏ': 'd', 'Đ': 'd', 'đ': 'd', 'ᵭ': 'd', 'Ɖ': 'd', 'ɖ': 'd', 'Ɗ': 'd', 'ɗ': 'd', 'Ƌ': 'd', 'ƌ': 'd', 'ȡ': 'd', 'ð': 'd', 'É': 'e', 'Ə': 'e', 'Ǝ': 'e', 'ǝ': 'e', 'é': 'e', 'È': 'e', 'è': 'e', 'Ĕ': 'e', 'ĕ': 'e', 'Ê': 'e', 'ê': 'e', 'Ế': 'e', 'ế': 'e', 'Ề': 'e', 'ề': 'e', 'Ễ': 'e', 'ễ': 'e', 'Ể': 'e', 'ể': 'e', 'Ě': 'e', 'ě': 'e', 'Ë': 'e', 'ë': 'e', 'Ẽ': 'e', 'ẽ': 'e', 'Ė': 'e', 'ė': 'e', 'Ȩ': 'e', 'ȩ': 'e', 'Ḝ': 'e', 'ḝ': 'e', 'Ę': 'e', 'ę': 'e', 'Ē': 'e', 'ē': 'e', 'Ḗ': 'e', 'ḗ': 'e', 'Ḕ': 'e', 'ḕ': 'e', 'Ẻ': 'e', 'ẻ': 'e', 'Ȅ': 'e', 'ȅ': 'e', 'Ȇ': 'e', 'ȇ': 'e', 'Ẹ': 'e', 'ẹ': 'e', 'Ệ': 'e', 'ệ': 'e', 'Ḙ': 'e', 'ḙ': 'e', 'Ḛ': 'e', 'ḛ': 'e', 'Ɇ': 'e', 'ɇ': 'e', 'ɚ': 'e', 'ɝ': 'e', 'Ḟ': 'f', 'ḟ': 'f', 'ᵮ': 'f', 'Ƒ': 'f', 'ƒ': 'f', 'Ǵ': 'g', 'ǵ': 'g', 'Ğ': 'g', 'ğ': 'g', 'Ĝ': 'g', 'ĝ': 'g', 'Ǧ': 'g', 'ǧ': 'g', 'Ġ': 'g', 'ġ': 'g', 'Ģ': 'g', 'ģ': 'g', 'Ḡ': 'g', 'ḡ': 'g', 'Ǥ': 'g', 'ǥ': 'g', 'Ɠ': 'g', 'ɠ': 'g', 'Ĥ': 'h', 'ĥ': 'h', 'Ȟ': 'h', 'ȟ': 'h', 'Ḧ': 'h', 'ḧ': 'h', 'Ḣ': 'h', 'ḣ': 'h', 'Ḩ': 'h', 'ḩ': 'h', 'Ḥ': 'h', 'ḥ': 'h', 'Ḫ': 'h', 'ḫ': 'h', 'H': 'h', '̱': 'h', 'ẖ': 'h', 'Ħ': 'h', 'ħ': 'h', 'Ⱨ': 'h', 'ⱨ': 'h', 'Í': 'i', 'í': 'i', 'Ì': 'i', 'ì': 'i', 'Ĭ': 'i', 'ĭ': 'i', 'Î': 'i', 'î': 'i', 'Ǐ': 'i', 'ǐ': 'i', 'Ï': 'i', 'ï': 'i', 'Ḯ': 'i', 'ḯ': 'i', 'Ĩ': 'i', 'ĩ': 'i', 'İ': 'i', 'i': 'i', 'Į': 'i', 'į': 'i', 'Ī': 'i', 'ī': 'i', 'Ỉ': 'i', 'ỉ': 'i', 'Ȉ': 'i', 'ȉ': 'i', 'Ȋ': 'i', 'ȋ': 'i', 'Ị': 'i', 'ị': 'i', 'Ḭ': 'i', 'ḭ': 'i', 'I': 'i', 'ı': 'i', 'Ɨ': 'i', 'ɨ': 'i', 'Ĵ': 'j', 'ĵ': 'j', 'J': 'j', '̌': 'j', 'ǰ': 'j', 'ȷ': 'j', 'Ɉ': 'j', 'ɉ': 'j', 'ʝ': 'j', 'ɟ': 'j', 'ʄ': 'j', 'Ḱ': 'k', 'ḱ': 'k', 'Ǩ': 'k', 'ǩ': 'k', 'Ķ': 'k', 'ķ': 'k', 'Ḳ': 'k', 'ḳ': 'k', 'Ḵ': 'k', 'ḵ': 'k', 'Ƙ': 'k', 'ƙ': 'k', 'Ⱪ': 'k', 'ⱪ': 'k', 'Ĺ': 'a', 'ĺ': 'l', 'Ľ': 'l', 'ľ': 'l', 'Ļ': 'l', 'ļ': 'l', 'Ḷ': 'l', 'ḷ': 'l', 'Ḹ': 'l', 'ḹ': 'l', 'Ḽ': 'l', 'ḽ': 'l', 'Ḻ': 'l', 'ḻ': 'l', 'Ł': 'l', 'ł': 'l', '̣': 'l', 'Ŀ': 'l', 'ŀ': 'l', 'Ƚ': 'l', 'ƚ': 'l', 'Ⱡ': 'l', 'ⱡ': 'l', 'Ɫ': 'l', 'ɫ': 'l', 'ɬ': 'l', 'ɭ': 'l', 'ȴ': 'l', 'Ḿ': 'm', 'ḿ': 'm', 'Ṁ': 'm', 'ṁ': 'm', 'Ṃ': 'm', 'ṃ': 'm', 'ɱ': 'm', 'Ń': 'n', 'ń': 'n', 'Ǹ': 'n', 'ǹ': 'n', 'Ň': 'n', 'ň': 'n', 'Ñ': 'n', 'ñ': 'n', 'Ṅ': 'n', 'ṅ': 'n', 'Ņ': 'n', 'ņ': 'n', 'Ṇ': 'n', 'ṇ': 'n', 'Ṋ': 'n', 'ṋ': 'n', 'Ṉ': 'n', 'ṉ': 'n', 'Ɲ': 'n', 'ɲ': 'n', 'Ƞ': 'n', 'ƞ': 'n', 'ɳ': 'n', 'ȵ': 'n', 'N': 'n', 'n': 'n', 'Ó': 'o', 'ó': 'o', 'Ò': 'o', 'ò': 'o', 'Ŏ': 'o', 'ŏ': 'o', 'Ô': 'o', 'ô': 'o', 'Ố': 'o', 'ố': 'o', 'Ồ': 'o', 'ồ': 'o', 'Ỗ': 'o', 'ỗ': 'o', 'Ổ': 'o', 'ổ': 'o', 'Ǒ': 'o', 'ǒ': 'o', 'Ö': 'o', 'ö': 'o', 'Ȫ': 'o', 'ȫ': 'o', 'Ő': 'o', 'ő': 'o', 'Õ': 'o', 'õ': 'o', 'Ṍ': 'o', 'ṍ': 'o', 'Ṏ': 'o', 'ṏ': 'o', 'Ȭ': 'o', 'ȭ': 'o', 'Ȯ': 'o', 'ȯ': 'o', 'Ȱ': 'o', 'ȱ': 'o', 'Ø': 'o', 'ø': 'o', 'Ǿ': 'o', 'ǿ': 'o', 'Ǫ': 'o', 'ǫ': 'o', 'Ǭ': 'o', 'ǭ': 'o', 'Ō': 'o', 'ō': 'o', 'Ṓ': 'o', 'ṓ': 'o', 'Ṑ': 'o', 'ṑ': 'o', 'Ỏ': 'o', 'ỏ': 'o', 'Ȍ': 'o', 'ȍ': 'o', 'Ȏ': 'o', 'ȏ': 'o', 'Ơ': 'o', 'ơ': 'o', 'Ớ': 'o', 'ớ': 'o', 'Ờ': 'o', 'ờ': 'o', 'Ỡ': 'o', 'ỡ': 'o', 'Ở': 'o', 'ở': 'o', 'Ợ': 'o', 'ợ': 'o', 'Ọ': 'o', 'ọ': 'o', 'Ộ': 'o', 'ộ': 'o', 'Ɵ': 'o', 'ɵ': 'o', 'Ṕ': 'p', 'ṕ': 'p', 'Ṗ': 'p', 'ṗ': 'p', 'Ᵽ': 'p', 'Ƥ': 'p', 'ƥ': 'p', 'P': 'p', '̃': 'p', 'p': 'p', 'ʠ': 'q', 'Ɋ': 'q', 'ɋ': 'q', 'Ŕ': 'r', 'ŕ': 'r', 'Ř': 'r', 'ř': 'r', 'Ṙ': 'r', 'ṙ': 'r', 'Ŗ': 'r', 'ŗ': 'r', 'Ȑ': 'r', 'ȑ': 'r', 'Ȓ': 'r', 'ȓ': 'r', 'Ṛ': 'r', 'ṛ': 'r', 'Ṝ': 'r', 'ṝ': 'r', 'Ṟ': 'r', 'ṟ': 'r', 'Ɍ': 'r', 'ɍ': 'r', 'ᵲ': 'r', 'ɼ': 'r', 'Ɽ': 'r', 'ɽ': 'r', 'ɾ': 'r', 'ᵳ': 'r', 'ß': 's', 'Ś': 's', 'ś': 's', 'Ṥ': 's', 'ṥ': 's', 'Ŝ': 's', 'ŝ': 's', 'Š': 's', 'š': 's', 'Ṧ': 's', 'ṧ': 's', 'Ṡ': 's', 'ṡ': 's', 'ẛ': 's', 'Ş': 's', 'ş': 's', 'Ṣ': 's', 'ṣ': 's', 'Ṩ': 's', 'ṩ': 's', 'Ș': 's', 'ș': 's', 'ʂ': 's', 'S': 's', 's': 's', '̩': 's', 'Þ': 't', 'þ': 't', 'Ť': 't', 'ť': 't', 'T': 't', '̈': 't', 'ẗ': 't', 'Ṫ': 't', 'ṫ': 't', 'Ţ': 't', 'ţ': 't', 'Ṭ': 't', 'ṭ': 't', 'Ț': 't', 'ț': 't', 'Ṱ': 't', 'ṱ': 't', 'Ṯ': 't', 'ṯ': 't', 'Ŧ': 't', 'ŧ': 't', 'Ⱦ': 't', 'ⱦ': 't', 'ᵵ': 't', 'ƫ': 't', 'Ƭ': 't', 'ƭ': 't', 'Ʈ': 't', 'ʈ': 't', 'ȶ': 't', 'Ú': 'u', 'ú': 'u', 'Ù': 'u', 'ù': 'u', 'Ŭ': 'u', 'ŭ': 'u', 'Û': 'u', 'û': 'u', 'Ǔ': 'u', 'ǔ': 'u', 'Ů': 'u', 'ů': 'u', 'Ü': 'u', 'ü': 'u', 'Ǘ': 'u', 'ǘ': 'u', 'Ǜ': 'u', 'ǜ': 'u', 'Ǚ': 'u', 'ǚ': 'u', 'Ǖ': 'u', 'ǖ': 'u', 'Ű': 'u', 'ű': 'u', 'Ũ': 'u', 'ũ': 'u', 'Ṹ': 'u', 'ṹ': 'u', 'Ų': 'u', 'ų': 'u', 'Ū': 'u', 'ū': 'u', 'Ṻ': 'u', 'ṻ': 'u', 'Ủ': 'u', 'ủ': 'u', 'Ȕ': 'u', 'ȕ': 'u', 'Ȗ': 'u', 'ȗ': 'u', 'Ư': 'u', 'ư': 'u', 'Ứ': 'u', 'ứ': 'u', 'Ừ': 'u', 'ừ': 'u', 'Ữ': 'u', 'ữ': 'u', 'Ử': 'u', 'ử': 'u', 'Ự': 'u', 'ự': 'u', 'Ụ': 'u', 'ụ': 'u', 'Ṳ': 'u', 'ṳ': 'u', 'Ṷ': 'u', 'ṷ': 'u', 'Ṵ': 'u', 'ṵ': 'u', 'Ʉ': 'u', 'ʉ': 'u', 'Ṽ': 'v', 'ṽ': 'v', 'Ṿ': 'v', 'ṿ': 'v', 'Ʋ': 'v', 'ʋ': 'v', 'Ẃ': 'w', 'ẃ': 'w', 'Ẁ': 'w', 'ẁ': 'w', 'Ŵ': 'w', 'ŵ': 'w', 'W': 'w', 'ẘ': 'w', 'Ẅ': 'w', 'ẅ': 'w', 'Ẇ': 'w', 'ẇ': 'w', 'Ẉ': 'w', 'ẉ': 'w', 'Ẍ': 'x', 'ẍ': 'x', 'Ẋ': 'x', 'ẋ': 'x', 'Ý': 'y', 'ý': 'y', 'Ỳ': 'y', 'ỳ': 'y', 'Ŷ': 'y', 'ŷ': 'y', 'Y': 'y', '̊': 'y', 'ẙ': 'y', 'Ÿ': 'y', 'ÿ': 'y', 'Ỹ': 'y', 'ỹ': 'y', 'Ẏ': 'y', 'ẏ': 'y', 'Ȳ': 'y', 'ȳ': 'y', 'Ỷ': 'y', 'ỷ': 'y', 'Ỵ': 'y', 'ỵ': 'y', 'ʏ': 'y', 'Ɏ': 'y', 'ɏ': 'y', 'Ƴ': 'y', 'ƴ': 'y', 'Ź': 'z', 'ź': 'z', 'Ẑ': 'z', 'ẑ': 'z', 'Ž': 'z', 'ž': 'z', 'Ż': 'z', 'ż': 'z', 'Ẓ': 'z', 'ẓ': 'z', 'Ẕ': 'z', 'ẕ': 'z', 'Ƶ': 'z', 'ƶ': 'z', 'Ȥ': 'z', 'ȥ': 'z', 'ʐ': 'z', 'ʑ': 'z', 'Ⱬ': 'z', 'ⱬ': 'z', 'Ǯ': 'z', 'ǯ': 'z', 'ƺ': 'z',}
    var ret = ''
    for (var i=0; i<s.length; i++) ret += accent_map[s.charAt(i)] || s.charAt(i)
    return ret
  }

  sendToProfile = (event) => {
    const { classrooms, goTo, setActiveStudentId, setActiveClassroomId, setSearchName } = this.props
    const value = event.currentTarget.id.split(',')
    const id = value[0]
    const classroom = value[1]
    const room = classrooms.find(r => r.name === classroom)
    setSearchName(value[2])
    setActiveStudentId(Number(id))
    setActiveClassroomId(Number(room.id))
    goTo(`/classroom/${room.id}/student/${id}`)
  }

  getBannerQA = () => SENTRY_ENV !== 'production' ? <TituloQA><Title2 style={{paddingLeft:'40%'}}>AMBIENTE PRUEBAS</Title2></TituloQA> : null

  /**
   * To open profile page
   */
  openProfile = () => null

  /**
   * To open settings page
   */
  openSettings = () => null

  /**
   * Logout from the platform
   */
  logout = () => {
    const { logout, postUserTokenFCM, user:{ id } } = this.props
    if (this.context.accounts.length > 0) {
      this.context.instance.logoutPopup({
        postLogoutRedirectUri: "/",
        // mainWindowRedirectUri:"/login"
      }).then(() => logout())
    } else {
      logout()
    }
    localStorage.setItem('advenio_token_fcm', '')
    postUserTokenFCM(id,{'token_fcm':null})

  }

  pages = () => {
    const { user } = this.props
    if (user.role === 'Nurse') {
      return nursePages
    } else if (user.role === 'Teacher') {
      return teacherPages
    } else if (stringContainsExactlyOf(user.role,['Back Office Admin','Back Office MiAdvenio','Back Office Talisis'])) {
      return backOfficePages
    } else if (user.role === 'Director') {
      return directorPages
    } else if (user.role === 'Coordinator') {
      return coordinatorPages
    }

    return normalPages
  }

  /**
   * Toggle sidebar drawer
   */
  toggleSidebar = () => this.setState({
    drawerOpened: true,
  })

  goToSOS = () => {
    this.props.stopImpersonateUser()
    this.props.setSearchName('')
    this.props.goTo('/')
    this.props.resetClassroom()
    this.props.setCenter('')
    this.props.setCenterName('')
  }

  goHome = () => {
    const { goHome, setSearchName } = this.props
    setSearchName('')
    goHome()
  }

  renderSearchResults = () => {
    if (this.state.results.length > 0) {
      return (
        <SearchStudentContainer>
          {this.state.results.map((currentValue) => {
            const { active, student: { classroom, student } } = currentValue
            const studentName = `${student.first_name || ''} ${student.last_name_paternal || ''} ${student.last_name_maternal || ''}`
            return (
              <SearchStudentDiv
                active={active}
                key={`${student.id},${classroom},${studentName}`}
                id={`${student.id},${classroom},${studentName}`}
                onClick={this.sendToProfile}
              >
                <SearchStudentInfo active={active}>
                  <InitialDiv>
                    {student.first_name[0]}{student.last_name_paternal[0]}
                  </InitialDiv>
                  <StudentName>
                    {`${student.first_name || ''} ${student.last_name_paternal || ''} ${student.last_name_maternal || ''}`}
                  </StudentName>
                </SearchStudentInfo>
                <SeeProfile>{classroom}</SeeProfile>
              </SearchStudentDiv>
            )
          })}
        </SearchStudentContainer>
      )
    }
    return (
      <SearchStudentContainer>
        <NoResults>
          No hay resultados para tu busqueda
        </NoResults>
      </SearchStudentContainer>
    )
  }

  getProfileImage = ()=> {
    const { postUserPicture, user:{id}, loadingPic } = this.props
    const blobObj = localStorage.getItem('image_profile') || defaultProfileImage;

    return blobObj
  }

  render() {
    const { openSearchBar, activity, closeSearchBar, goHome, openActivity,
      isSearchBarOpen, slot, user, center } = this.props
    const { activePlatformIndex, drawerOpened, platforms, results, support, chatIaEnabled } = this.state
    return (
      <div>
        <ModalSupport
          show={moment(performance.now()).format('ss') < 8 &&  ( support.is_support)}
          message={ <span> Le informamos que este próximo <b>{support.date}</b>, se estará realizando un <b>mantenimiento preventivo</b> en un horario de <b> {support.time} (UTC)</b>.</span>}
        />
        {(user.is_impersonating && user.center) &&
        <Impersonate>
          <Img src="/assets/Warning.svg" alt="warning" />
          <span>{`Estás visualizando el usuario (`}<b>{user.first_name} {user.last_name_paternal} {user.last_name_maternal} {user.center && user.center.abbreviation}</b>{'), presiona '}
            <Underline onClick={this.goToSOS}>AQUÍ</Underline>
            {' para volver a tus funciones de SOS.'}
          </span>
        </Impersonate>
        }
        <MainNav
          platform={'MiAdvenio'}
          toggleSidebar={this.toggleSidebar}
          userName={user.first_name}
          searchBar={
            <SearchBar
              onFocus={openSearchBar}
              onKeyDown={this.onKeyDown}
              onChange={this.onChange}
              value={this.props.searchName}
            />
          }
          onLogoClick={this.goHome}
          onMenuClick={() => { this.setState({ drawerOpened: !drawerOpened }) }}
          mobileActions={activity ? <GroupActivityButton GroupClick={openActivity} /> : ''}
          showMobileActions={user.role === 'Teacher' || user.role === 'Nurse' || user.role === 'Director'}
          profilePicture={user.profile_pictures !== null ? user.profile_pictures['original'] : this.getProfileImage()}

        />
        <LeftDrawer
          isOpen={drawerOpened}
          userName={user.first_name}
          pages={this.pages()}
          onPageSelected={this.onPageSelected}
          selectedPage={this.props.match.path}
          platforms={platforms}
          onPlatformSelected={this.onPlatformSelected}
          selectedPlatform={activePlatformIndex}
          // openProfile={this.openProfile}
          // openSettings={this.openSettings}
          logout={this.logout}
          onCloseCallback={() => this.setState({ drawerOpened: false })}
          profilePicture={user.profile_pictures !== null ? user.profile_pictures['original'] : this.getProfileImage()}
        />
        { this.getBannerQA()}
        <GrowthBookBanner />
        {slot}
        <SearchContainer
          impersonating={user.is_impersonating}
          active={isSearchBarOpen}
          onClick={closeSearchBar}
        >
          {!this.state.empty &&
            <SearchBox impersonating={user.is_impersonating}>
              {this.renderSearchResults()}</SearchBox>}
        </SearchContainer>
        <ChatWidget
          apiBaseUrl={API_DOMAIN}
          token={getCookie('advenio_api_key') || ''}
          enabled={chatIaEnabled}
        />
      </div>
    )
  }
}

Layout.propTypes = {
  /** Flag marking whether the current view should display the Group Activity button */
  activity: PropTypes.bool,
  /** An array of classrooms */
  classrooms: PropTypes.array.isRequired,
  /** Callback to be fired when closing the search bar */
  closeSearchBar: PropTypes.func.isRequired,
  /** The primary page content to be displayed */
  slot: PropTypes.node.isRequired,
  /** Navigate back to the home page */
  goHome: PropTypes.func.isRequired,
  /** Navigate to the given path */
  goTo: PropTypes.func.isRequired,
  /** Log out of the platform */
  logout: PropTypes.func.isRequired,
  /** Open the group activity modal */
  openActivity: PropTypes.func.isRequired,
  /** Set the ID of the selected student in the search bar */
  setActiveStudentId: PropTypes.func.isRequired,
  /** Flag indicating if the search bar is active or not */
  isSearchBarOpen: PropTypes.bool.isRequired,
  /** Open the search bar located in the MainNav */
  openSearchBar: PropTypes.func.isRequired,
  /** An array of all students */
  totalStudents: PropTypes.array.isRequired,

  stopImpersonateUser: PropTypes.func.isRequired,
}

Layout.defaultProps = {
  activity: false,
}

const mapStateToProps = ({ auth, classrooms, centerOptions }) => ({
  user: auth.user,
  center: centerOptions.get.results.find(center => center.id === auth.user.center_id),
  classrooms: classrooms.get.results,
  isSearchBarOpen: classrooms.isSearchBarOpen,
  openSearchBar: classrooms.openSearchBar,
  totalStudents: classrooms.totalStudents,
  searchValue: classrooms.searchValue,
  searchName: classrooms.searchName,
})

const mapDispatchToProps = dispatch => ({
  goHome: () => dispatch(push('/')),
  goTo: path => dispatch(push(path)),
  logout: () => dispatch(AuthRedux.Actions.logout({ shouldDeleteCookies: true })),
  stopImpersonateUser: () => dispatch(AuthRedux.Actions.stopImpersonateUserRequest()),
  openActivity: () => dispatch(ActivityActions.openActivity()),
  openSearchBar: () => dispatch(ClassroomActions.openSearchBar()),
  closeSearchBar: () => dispatch(ClassroomActions.closeSearchBar()),
  searchValue: value => dispatch(ClassroomActions.searchValue(value)),
  setActiveStudentId: id => dispatch(ClassroomActions.setActiveStudentId(id)),
  setSearchName: name => dispatch(ClassroomActions.setSearchName(name)),
  setActiveClassroomId: id => dispatch(ClassroomActions.setActiveClassroomId(id)),
  resetClassroom: () => dispatch(ClassroomActions.resetClassroom()),
  postUserPicture:(id,data) => dispatch(UsersActions.postUserPicutreRequest(id,data)),
  postUserTokenFCM: (id, data) => dispatch(UsersActions.postUserTokenFCMRequest(id, data)),
  setCenter: id => dispatch(CentersInfoActions.setCenter(id)),
  setCenterName: id => dispatch(CentersInfoActions.setCenter(id)),

})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout))



// WEBPACK FOOTER //
// ./src/Containers/Layout.jsx